import { Flex, Text } from "@chakra-ui/react";
import { useRef } from "react";
import { BoardColumn, Lead } from "../../../models/Lead";
import { crm } from "./crmTheme";
import LeadColumn from "./LeadColumn";

// Visão "funil" do CRM (uma das visões possíveis — futuramente teremos calendário).
// Drag-and-drop nativo: arrastar um card para outra coluna muda o status do lead.
const LeadBoard = ({
  columns,
  onMove,
  onLeadClick,
  onLeadDelete,
}: {
  columns: BoardColumn[];
  onMove: (lead: Lead, targetColumn: BoardColumn) => void;
  onLeadClick: (lead: Lead) => void;
  onLeadDelete: (lead: Lead) => void;
}) => {
  const draggedLead = useRef<Lead | null>(null);

  const handleDragStart = (e: React.DragEvent, lead: Lead) => {
    draggedLead.current = lead;
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/plain", lead.id ?? "");
  };

  const handleDrop = (_e: React.DragEvent, column: BoardColumn) => {
    const lead = draggedLead.current;
    draggedLead.current = null;
    if (!lead) return;
    if (lead.prospectStatusId === column.status.id) return; // mesma coluna
    onMove(lead, column);
  };

  if (columns.length === 0) {
    return (
      <Flex w="100%" justify="center" align="center" minH="300px">
        <Text color={crm.textMuted}>
          Nenhuma coluna criada. Clique em "Gerenciar status" para criar as
          etapas do funil.
        </Text>
      </Flex>
    );
  }

  return (
    <Flex
      gap="16px"
      overflowX="auto"
      pb="16px"
      h="calc(100vh - 230px)"
      align="stretch"
    >
      {columns.map((column) => (
        <LeadColumn
          key={column.status.id ?? "no-status"}
          column={column}
          onDragStartCard={handleDragStart}
          onDropInColumn={handleDrop}
          onLeadClick={onLeadClick}
          onLeadDelete={onLeadDelete}
        />
      ))}
    </Flex>
  );
};

export default LeadBoard;
